
export function CompanyInfoSection() {
  return (
    <div className="bg-white">
      {/* Orange Banner Section */}
      <div className="bg-orange-400 py-6">
        <div className="container mx-auto px-4">
          <h2 className="text-white text-xl md:text-2xl font-bold text-center">
            Contact us for 24-hour On-call AOG Parts & Maintenance
          </h2>
        </div>
      </div>

      {/* Contact Info Columns */}
      <div className="bg-gray-50 py-8">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            {/* Office Line */}
            <div>
              <div className="text-orange-400 text-sm font-semibold uppercase tracking-wide mb-2">
                Office Line
              </div>
              <div className="text-gray-800 text-2xl font-bold">
                859.255.1902
              </div>
            </div>

            {/* AOG 24-HR ON-CALL */}
            <div>
              <div className="text-orange-400 text-sm font-semibold uppercase tracking-wide mb-2">
                AOG 24-HR ON-CALL
              </div>
              <div className="text-gray-800 text-2xl font-bold">
                859.255.1902
              </div>
            </div>

            {/* Regular Hours */}
            <div>
              <div className="text-orange-400 text-sm font-semibold uppercase tracking-wide mb-2">
                Regular Hours
              </div>
              <div className="text-gray-800 text-2xl font-bold">
                8:00am – 4:30pm
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}